import { useState } from 'react';
import Box from '@mui/material/Box';
import Divder from '../../Components/CommonComp/Divder';
import CustomBox from '../../Components/CommonComp/CustomBox/CustomBox';
import LegalTabBody from '../../Components/Legal/LegalTabBody';
import { LegalData } from '../../data/LegalData';
import CustomTabExpand from '../../Components/CommonComp/CustomTabs/CustomTabExpand';

function Legal({ handleNavParams }) {
  const [tabValue, setTabValue] = useState(1);

  const handleTabs = (data) => {
    setTabValue(data.id);
    handleNavParams({
      navTitle: data.label,
    });
  };
  return (
    <Box
      component="main"
      sx={(theme) => {
        return {
          flexGrow: 1,
        };
      }}
    >
      <CustomBox padding={0}>
        
        <CustomTabExpand tabList={LegalData?.tabs} tabClick={handleTabs} />
      </CustomBox>
      <Divder spacing={1} />
      <LegalTabBody activeTab={tabValue} />
      <Divder spacing={1.2} />
    </Box>
  );
}

export default Legal;
